import type { ComponentProps } from "react"

export default function PropertyAgriculture(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M14.6666 2.6665H17.3333V5.33317H14.6666V2.6665ZM19.7706 6.34384L21.6573 4.4585L23.5426 6.34384L21.656 8.22917L19.7706 6.34384ZM22.6666 10.6665H25.3333V13.3332H22.6666V10.6665ZM8.45863 6.34384L10.344 4.45717L12.2293 6.34384L10.344 8.22917L8.45863 6.34384ZM6.66663 10.6665H9.33329V13.3332H6.66663V10.6665ZM3.99996 15.9998C3.64634 15.9998 3.3072 16.1403 3.05715 16.3904C2.8071 16.6404 2.66663 16.9795 2.66663 17.3332V27.1105L9.33329 15.9998H3.99996ZM17.3333 15.9998L18.6666 29.3332H24L20 15.9998H17.3333ZM28 15.9998H22.6666L29.3333 27.1105V17.3332C29.3333 16.9795 29.1928 16.6404 28.9428 16.3904C28.6927 16.1403 28.3536 15.9998 28 15.9998ZM7.99996 29.3332H13.3333L14.6666 15.9998H12L7.99996 29.3332ZM10.6666 11.9998C10.6715 12.9388 10.927 13.8593 11.4066 14.6665H20.5933C21.073 13.8593 21.3284 12.9388 21.3333 11.9998C21.3333 10.5853 20.7714 9.22879 19.7712 8.2286C18.771 7.22841 17.4144 6.6665 16 6.6665C14.5855 6.6665 13.2289 7.22841 12.2287 8.2286C11.2285 9.22879 10.6666 10.5853 10.6666 11.9998Z"
        fill={fill}
      />
    </svg>
  )
}
